import joinClassNames from '@/utils/functions/joinClassNames/joinClassNames';

import styles from './styles.module.css';

interface VideoTutorialRowProps {
  title: string;
  duree: string;
  isSelected?: boolean;
  onClick: () => void;
}

const VideoTutorialRow = ({ title, duree, isSelected = false, onClick }: VideoTutorialRowProps) => (
  <button
    type="button"
    className={joinClassNames(styles.videoTutorialRow, isSelected && styles.selected)}
    aria-current={isSelected || undefined}
    onClick={onClick}
  >
    <span className={styles.playBadge} aria-hidden="true">
      <i className="totem-icon totem-icon-play" />
    </span>
    <span className={styles.texts}>
      <span className={styles.title}>{title}</span>
      <span className={styles.duree}>{duree}</span>
    </span>
    {!isSelected && <i className={`totem-icon totem-icon-chevron-right ${styles.chevron}`} aria-hidden="true" />}
  </button>
);

export default VideoTutorialRow;
